const shortenString = (s) => {
    return s.length > 103 ? `${s.substring(0, 100)}...` : s;
};

const convertStringToOption = (value, name) => {
    return {
        value,
        text: shortenString(`${name}: ${value}`),
    };
};

export const valueByTypeToArray = (value, type, name) => {
    if (!value) {
        return [];
    }

    switch (type) {
        case "String":
            return [convertStringToOption(value, name)];
        case "StringList":
            return value.map((t) => convertStringToOption(t, name));
        case "MultiDropdownCheckboxPicklist":
        case "MultiDropdownPicklist":
            return value.map((t) => convertStringToOption(t.text, name));
        default:
            return [];
    }
};
